import { sortBySortOrder } from '@/utils/sort';
import type {
  CreateSurveyFormValues,
  CreateSurveyPayload,
  SurveyDetail,
  UpdateSurveyFormValues,
  UpdateSurveyPayload,
} from '../types/survey.types';

export function toCreateSurveyPayload(values: CreateSurveyFormValues): CreateSurveyPayload {
  return {
    title: values.title.trim(),
    ...(values.description?.trim() ? { description: values.description.trim() } : {}),
    startDate: values.startDate,
    endDate: values.endDate,
    questions: values.questions.map((question, index) => ({
      text: question.text.trim(),
      type: question.type,
      sortOrder: index + 1,
      ...(question.answerType ? { answerType: question.answerType } : {}),
      ...(question.isRequired !== undefined ? { isRequired: question.isRequired } : {}),
      ...(question.minValue !== undefined ? { minValue: question.minValue } : {}),
      ...(question.maxValue !== undefined ? { maxValue: question.maxValue } : {}),
      ...(question.maxChars !== undefined ? { maxChars: question.maxChars } : {}),
      ...(question.options
        ? {
            options: question.options.map((option, optionIndex) => ({
              text: option.text.trim(),
              sortOrder: optionIndex + 1,
            })),
          }
        : {}),
    })),
  };
}

export function toUpdateSurveyPayload(values: UpdateSurveyFormValues): UpdateSurveyPayload {
  const trimmedDescription = values.description?.trim() ?? '';
  return {
    title: values.title.trim(),
    description: trimmedDescription.length > 0 ? trimmedDescription : null,
    startDate: values.startDate,
    endDate: values.endDate,
    questions: values.questions.map((question, index) => ({
      ...(question.id !== undefined ? { id: question.id } : {}),
      text: question.text.trim(),
      type: question.type,
      sortOrder: index + 1,
      ...(question.answerType ? { answerType: question.answerType } : {}),
      ...(question.isRequired !== undefined ? { isRequired: question.isRequired } : {}),
      ...(question.minValue !== undefined ? { minValue: question.minValue } : {}),
      ...(question.maxValue !== undefined ? { maxValue: question.maxValue } : {}),
      ...(question.maxChars !== undefined ? { maxChars: question.maxChars } : {}),
      ...(question.options
        ? {
            options: question.options.map((option, optionIndex) => ({
              ...(option.id !== undefined ? { id: option.id } : {}),
              text: option.text.trim(),
              sortOrder: optionIndex + 1,
            })),
          }
        : {}),
    })),
  };
}

export function toSurveyFormDefaultValues(survey: SurveyDetail): UpdateSurveyFormValues {
  const sortedQuestions = sortBySortOrder(survey.questions);
  return {
    title: survey.title,
    description: survey.description ?? '',
    startDate: survey.startDate,
    endDate: survey.endDate,
    questions: sortedQuestions.map((question) => ({
      id: question.id,
      text: question.text,
      type: question.type,
      ...(question.answerType ? { answerType: question.answerType } : {}),
      ...(question.isRequired !== null ? { isRequired: question.isRequired } : {}),
      ...(question.minValue !== null ? { minValue: question.minValue } : {}),
      ...(question.maxValue !== null ? { maxValue: question.maxValue } : {}),
      ...(question.maxChars !== null ? { maxChars: question.maxChars } : {}),
      ...(question.options.length > 0
        ? {
            options: sortBySortOrder(question.options).map((option) => ({
              id: option.id,
              text: option.text,
            })),
          }
        : {}),
    })),
  };
}
